// @flow

import ItemInformation from './ItemInformation'

export default ItemInformation
